var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5371",
    "data-name": "Path 5371",
    d: "M1018,580v-6.54a6.946,6.946,0,0,1,2.47,1.59l3.48,3.486a6.959,6.959,0,0,1,1.59,2.464H1019a1,1,0,0,1-.71-.293A1.029,1.029,0,0,1,1018,580Zm8,3.485V592a5.012,5.012,0,0,1-5,5h-10a5.012,5.012,0,0,1-5-5V578a5.012,5.012,0,0,1,5-5h4.52c.16,0,.32.013.48.024V580a3,3,0,0,0,3,3h6.98C1025.99,583.161,1026,583.322,1026,583.485ZM1018,592a1.029,1.029,0,0,0-.29-.707A1,1,0,0,0,1017,591h-5a1,1,0,0,0-.71.293,1.007,1.007,0,0,0,0,1.414,1,1,0,0,0,.71.293h5a1,1,0,0,0,.71-.293A1.029,1.029,0,0,0,1018,592Zm3-4a1.029,1.029,0,0,0-.29-.707A1,1,0,0,0,1020,587h-8a1,1,0,0,0-.71.293,1.007,1.007,0,0,0,0,1.414,1,1,0,0,0,.71.293h8a1,1,0,0,0,.71-.293A1.029,1.029,0,0,0,1021,588Z",
    transform: "translate(-1006 -573)",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.e9c491eb2f35c94cb8ce05315ba4f653.svg";
export { ForwardRef as ReactComponent };